<template>
	<div>
		<div class="add-to-stream-section">
			<div class="content-section">
				<div class="add-to-stream-list">
					<b-form-select v-model="selectedStreamUuid" :options="formattedStreams" />
				</div>

				<div class="course-list-column">
					<div class="course-list-section" v-for="stream in formattedSubstreams">
						<div class="data-row">
							<span class="title" :title="stream.title">{{stream.title}}</span>
							<b-btn @click="removeButtonClicked(stream)" class="delete-btn" aria-label="remove from my stream" title="remove from my stream">x</b-btn>
						</div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'add-to-stream-explore',
    components: {

    },
    data: () => {
      return {
        userId: {},
        streamUuid: {}
      }
    },
    mounted () {
      this.userId = localStorage.getItem('userid')
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateStreamsForUser',
        'loadLogDashboardActivity',
        'loadExploreSubstreamEntities',
        'removeSubstreamEntity',
        'exploreStreamSelected'
      ]),
      loadData () {
        // this.populateStreamsForUser({userId: this.userId}).then(results => {
        //   let selectedStreamUuid = this.selectDefaultStream(results)
        //   this.loadExploreSubstreamEntities({streamUuid: selectedStreamUuid})
        // })
        // this.$forceUpdate()
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      onShown () {
        console.log('onShown called')
      },
      removeButtonClicked (substream) {
        let selectedStreamUuid = this.selectedStreamUuid
        this.removeSubstreamEntity({streamUuid: selectedStreamUuid, entityUuid: substream.originUuid}).then(response => {
          if (response) {
            this.notifySuccess('Successfully removed \'' + substream.title + '\' from your stream.')
          } else {
            this.notifyFailure('There was a problem removing \'' + substream.title + '\' from your stream.')
          }
          // this.$forceUpdate()
          this.loadExploreSubstreamEntities({streamUuid: selectedStreamUuid})
        })
        this.$forceUpdate()
      },
      streamSelected () {
        let streamUuid = this.selectedStreamUuid
        if (!streamUuid) {
          return
        }
        this.loadExploreSubstreamEntities({streamUuid: this.selectedStreamUuid})
        this.$forceUpdate()
      },
      selectDefaultStream (results) {
        if (!results || !results.length || results.length <= 0) {
          return {}
        }
        let userId = this.userId
        let defaultSet = false
        var streamUuid = {}
        results.forEach((stream) => {
          if (!defaultSet && stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
            streamUuid = stream.uuid
            defaultSet = true
          }
        })
        this.exploreStreamSelected({streamUuid: streamUuid})
        return streamUuid
      },
      createStreamClicked () {
        console.log('createStreamClicked ')
        window.location.href = '/stream/create.html'
      }
    },
    computed: {
      ...mapState({
        'streams': state => state.semester.streams,
        'substreams': state => state.explore.substreams,
        'institution': state => state.institution.institution,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'selectedStreamUuid': state => state.explore.selectedStreamUuid
      }),
      formattedSubstreams () {
        let formattedSubs = []
        let streams = this.substreams
        if (!streams) {
          return []
        }
        streams.forEach(function (stream) {
          formattedSubs.push(stream)
        })
        return formattedSubs
      },
      formattedStreams () {
        let userId = this.userId
        let streams = this.streams
        let formattedStreams = []
        streams.forEach(function (stream) {
          if (stream.streamType && stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
            formattedStreams.push({value: stream.uuid, text: stream.title})
          }
        })
        return formattedStreams
      }
    },
    watch: {
      selectedStreamUuid (newId) {
        // this.streamSelected()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/explore/components/AddToStreamExplore.vue